<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image2" /> -->
    <transition
      appear
      @before-enter="$animations.beforeEnterLogoArea"
      @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <transition
      appear
      @before-enter="$animations.beforeEnterAbove"
      @enter="$animations.enterAbove"
    >
      <div class="columns is-centered">
        <div
          v-if="$root.selectedLanguage === `en`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/updatedIcons/normalFlow/purposeInfo.png"
            alt="purpose.png"
            width="85%"
          />
        </div>
        <div
          v-if="$root.selectedLanguage === `si`"
          class="column"
          style="text-align: center"
        >
          <img
            src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37573.png"
            alt="purpose.png"
            width="70%"
          />
        </div>
      </div>
    </transition>
<div class=" card px-4" style="width: 80%; margin:auto">
    <transition
      appear
      @before-enter="$animations.beforeEnterAbove"
      @enter="$animations.enterAbove"
    >
      <div class="columns is-centered">
        <div class="column is-8 ps-5" style="text-align: center">
          <img
            src="../assets/images/icons/Blue/Group 159.png"
            alt="contact-info-img"
            width="70"
            height="70"
          />
          <p
            :class="`text-center mx-3 mb-2 ${
              $root.selectedLanguage === `ta`
                ? `ta-he-line`
                : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
            }`"
            style="font-family: OpenSans-Bold;"
          >
            {{ $root.selectedLanguageData.purpose }}
          </p>
          <p
            :class="`${
              $root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
            }`"
            style="font-family: OpenSans-Bold;"
          >
            {{ $root.selectedLanguageData.whyDoYouNeedToCreatAnAccount }}
          </p>
          <p style="font-family: OpenSans-Regular ;">
            {{ $root.selectedLanguageData.dataEditByButton }}
          </p>
        </div>
      </div>
    </transition>
<!--  v-slot="{ invalid }"-->
    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="onSubmit">
        <div class="columns is-centered">
          <transition
            appear
            @before-enter="$animations.beforeEnterBelow"
            @enter="$animations.enterBelow"
          >
            <div class="column is-three-quarters pt-4 ps-5">
              <div>
<!--                v-if="$root.kycFieldVisibility.purpose_of_opening"-->
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.purposeOfOpeningtheAccount
                  }}<span class="has-text-danger">*</span></label
                >
                <div style="width: 100%">
                  <b-field>
                    <p class="control has-icons-right">
                      <ValidationProvider name="purpose" :rules="{ required: true }" v-slot="{ errors }">
                      <b-autocomplete
                       
                        v-model="purpose"
                        :data="filteredDataArray"
                        open-on-focus
                        field="langTranslation"
                        @input=" ()=>{isPurposeTouched = true; if(purpose !== `Other`){
                    $root.formData.other_purpose_of_opening = ''
                  }}"
                        clearable
                        @select="
                          (option) => {
                            option
                              ? ($root.formData.purpose_of_opening = option)
                              : ``;
                          }
                        "

                      >

                      </b-autocomplete>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <span class="icon is-small is-right mr-2">
                        <img
                          src="../assets/images/icons/Blue/Stroke.png"
                          alt="Stroke-img"
                          width="13"
                          height="13"
                        />
                      </span></p
                  ></b-field>
                </div>
                <span
                  v-if="
                    isPurposeTouched &&
                    $root.formData.purpose_of_opening.langTranslation !==
                      purpose
                  "
                  class="has-text-danger"
                  >Purpose of opening the account is required</span
                >
              
              </div>
<!--              purpose of opening account section end-->

<!--              special reason of account open start-->
              <div class="mt-2" v-if="purpose === 'Other'">
                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.other_Purpose_of_opening_account
                  }}<span class="has-text-danger">*</span></label
                >

                <ValidationProvider name="Purpose" :rules="{ required: true, alphaSpaces: true, notStartsWith: ' ', notEndsWith:' '}" v-slot="{ errors }" >
                <b-field>
                  <b-input ype="text" @focus="$inputFocused('other_purpose_of_opening')"
                           @blur="$inputBlured('other_purpose_of_opening')"
                      v-model="$root.formData.other_purpose_of_opening"
                           @input="()=>{$inputChanged('other_purpose_of_opening');}">
                  </b-input>
                </b-field>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!--              special reason of account open end-->
<!-- source of funds and transaction volumes section start here-->
            <div class="mt-2 columns ">
              <div
                class="is-5 column"

              >
<!--                v-if="$root.kycFieldVisibility.source_of_income"-->
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.sourceOfFunds
                  }}<span class="has-text-danger">*</span></label
                >
                <div>
                  <ValidationProvider name="source of fund" :rules="{ required: true }" v-slot="{ errors }">
                    <b-select
                      @focus="$inputFocused('source_of_fund')"
                      @input="()=>{$inputChanged('source_of_fund'); if($root.formData.source_of_fund !== 'Other')
                        $root.formData.other_source_of_fund = ''
                      }"
                      @blur="$inputBlured('source_of_fund')"
                      v-model="$root.formData.source_of_fund"
                      expanded

                    >
                      <option
                        v-for="income in $root.selectedLanguageData
                          .sourceOfFundList"
                        :key="income.value"
                        :value="income.value"
                      >
                        {{ income.langTranslation }}
                      </option>
                    </b-select>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div
                  class="is-6 column is-offset-1"

              >
                <!--                v-if="$root.kycFieldVisibility.source_of_income"-->
                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.anticipated_transaction_volumes
                  }}<span class="has-text-danger">*</span></label
                >
                <div>
                  <ValidationProvider name="anticipated volume" rules="required" v-slot="{ errors }">
                    <b-select
                        @focus="$inputFocused('anticipated_vol')"
                        @input="$inputChanged('anticipated_vol')"
                        @blur="$inputBlured('anticipated_vol')"
                        v-model="$root.formData.anticipated_vol"
                        expanded
                    >
                      <option
                          v-for="income in $root.selectedLanguageData
                          .transactionVolumesAndExpectedTurnovers"
                          :key="income.value"
                          :value="income"
                      >
                        {{ income.langTranslation }}
                      </option>
                    </b-select>
                    <span class="has-text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

            </div>
              <!-- source of funds and transaction volumes section end here-->

              <!--              other source of funds start here-->
              <div class="mt-2" v-if="$root.formData.source_of_fund == 'Other'" >

                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.specify_the_source_of_funds
                  }}<span class="has-text-danger">*</span></label
                >
                <ValidationProvider name="Source Of Fund" :rules="{ required: true, alphaSpaces: true, notStartsWith: ' ', notEndsWith:' '}" v-slot="{ errors }">
                <b-field>
                  <b-input v-model="$root.formData.other_source_of_fund"></b-input>
                </b-field>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
             <!--              other source of funds end here-->

            <!--              Assets selection start here -->
              <div class="mt-4 column">
                <div class="columns">
                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.assets_held_by_yourself
                  }}<span class="has-text-danger">*</span></label
                >
                </div>


                    <div class="columns">
                  <div class = "column">
                    <b-checkbox v-model="$root.formData.asset_residential_property"
                                @click.native="()=>{if(!$root.formData.asset_residential_property){
                                  $root.formData.asset_residential_property_value = ''
                                }}"
                                :native-value=false>
                      Residential Property
                    </b-checkbox>
                  </div>

                    <div class = "column is-4 is-offset-5" v-if="$root.formData.asset_residential_property === true">
                    <b-field>
                      <ValidationProvider name="Residential property value" :rules="{required:$root.formData.asset_residential_property===true, noCharacters:true}" v-slot="{ errors }">
                      <b-input v-model="$root.formData.asset_residential_property_value"  placeholder="Rs." 
                               @focus="$inputFocused('asset_residential_property_value');" @blur="$inputBlured('asset_residential_property_value')"
                               @input="
                                  () => {
                                    $inputChanged('asset_residential_property_value');
                                    propertyMinMaxValidator()
                                    propertyRegexValidator()
                                    propertyThousendSeperator()
                                   
                                  } "

                                  
                               >
                      </b-input>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="!isPropertyValueInRange"> Property value is not in valid range </span>
                        <span class="has-text-danger" v-if="!isPropertyValueValid"> Property value is not in valid format</span>


                      </ValidationProvider>
                    </b-field>
                    </div>
                    </div>

                <div class="columns">
                  <div class = "column">
                    <b-checkbox v-model="$root.formData.asset_financial"
                                @click.native="()=>{if(!$root.formData.asset_financial){
                                  $root.formData.asset_financial_value = ''
                                }}"
                                :native-value=false>
                      Financial Assets
                    </b-checkbox>
                  </div>

                  <div class = "column is-4 is-offset-5" v-if="$root.formData.asset_financial === true">
                    <b-field>
                      <ValidationProvider name="Financial assets value" :rules="{ required:$root.formData.asset_financial===true}" v-slot="{ errors }">
                      <b-input v-model="$root.formData.asset_financial_value" placeholder="Rs."
                               @input="
                                  () => {
                                    // $inputChanged('asset_financial_value');
                                    financialRegexValidator()
                                    financialAssetThousendSeperator()
                                    financialMinMaxValidator()
                                  } "
                               >
                      </b-input>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="!isFinancialValueInRange"> Financial value is not in valid range</span>
                        <span class="has-text-danger" v-if="!isfinancialValueValid"> Financial value is not in valid format</span>

                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class = "column">
                    <b-checkbox v-model="$root.formData.asset_land_buildings"
                                :native-value=false
                                @click.native="()=>{if(!$root.formData.asset_land_buildings){
                                  $root.formData.asset_land_buildings_value = ''
                                }}">
                      Business
                    </b-checkbox>
                  </div>

                  <div class = "column is-4 is-offset-5" v-if="$root.formData.asset_land_buildings === true">
                    <b-field>
                      <ValidationProvider name="Business value" :rules="{required:$root.formData.asset_land_buildings===true}" v-slot="{ errors }">
                      <b-input v-model="$root.formData.asset_land_buildings_value" placeholder="Rs."
                               min="1"
                               max="999999999"
                               @input="
                                  () => {
                                    $inputChanged('asset_land_buildings_value');
                                    landBuildingsRegexValidator()
                                    landBuildingsAssetThousendSeperator();
                                    landBuildingMinMaxValidator();
                                  } "

                               >
                      </b-input>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="!isBusinessValueInRange"> Business value in not in valid range </span>
                        <span class="has-text-danger" v-if="!islandBuildingsValueValid"> Business value in not in valid format </span>

                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class = "column">
                    <b-checkbox v-model="$root.formData.asset_investments_shares"
                                :native-value=false
                                @click.native="()=>{if(!$root.formData.asset_investments_shares){
                                  $root.formData.asset_investments_shares_value = ''
                                }}">
                      Investment
                    </b-checkbox>
                  </div>

                  <div class = "column is-4 is-offset-5" v-if="$root.formData.asset_investments_shares===true">
                    <b-field>
                      <ValidationProvider name="Investment value" :rules="{ required:$root.formData.asset_investments_shares===true}" v-slot="{ errors }">
                      <b-input  v-model="$root.formData.asset_investments_shares_value"  placeholder="Rs."
                                min="1"
                                max="999999999"
                                @input="
                                  () => {
                                    $inputChanged('asset_investments_shares_value');
                                    investmentsRegexValidator();
                                    investmentsAssetThousendSeperator();
                                    investmentSharesMinMaxValidator()
                                  } "
                              >
                      </b-input>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="!isInvestmentValueInRange"> Investment shares value is not in valid range</span>
                        <span class="has-text-danger" v-if="!isinvestmentsValueValid"> Investment shares value is not in valid format</span>

                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class = "column">
                    <b-checkbox v-model="$root.formData.asset_motor_vehicles"
                                :native-value=false
                                @click.native="()=>{if(!$root.formData.asset_motor_vehicles){
                                  $root.formData.asset_motor_vehicles_value = ''
                                }}">
                      Motor Vehicles
                    </b-checkbox>
                  </div>

                  <div class = "column is-4 is-offset-5" v-if="$root.formData.asset_motor_vehicles===true">
                    <b-field>
                      <ValidationProvider name="Motor Vehicles" :rules="{ required:$root.formData.asset_motor_vehicles===true}" v-slot="{ errors }">
                      <b-input v-model="$root.formData.asset_motor_vehicles_value" placeholder="Rs."
                               min="1"
                               max="999999999"
                               @input="
                                  () => {
                                    $inputChanged('asset_investments_shares_value');
                                    motorVehiclesRegexValidator()
                                    motorVehicalsAssetThousendSeperator()
                                    motorVehiclesMinMaxValidator()

                                  } "

                              >
                      </b-input>
                        <span class="has-text-danger">{{ errors[0] }}</span>
                        <span class="has-text-danger" v-if="!isMotorValueInRange"> Motor vehicle value is not in valid range </span>
                        <span class="has-text-danger" v-if="!ismotorVehiclesValueValid"> Motor vehicle value is not in valid format </span>

                      </ValidationProvider>
                    </b-field>
                  </div>
                </div>

                <div class="columns">
                  <div class = "column">
                    <b-checkbox v-model="$root.formData.asset_other"
                                :native-value=false
                                @click.native="()=>{if(!$root.formData.asset_other){
                                  $root.formData.other_assets_held = ''
                                  $root.formData.asset_other_value = ''
                                }}">
                      Other
                    </b-checkbox>
                  </div>


                </div>


              </div>

              <!--              Assets selection end here -->

<!--              other asset section start here-->
              <div class="columns" v-if="$root.formData.asset_other">
              <div class="is-6 column" >
                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.specify_the_assets_held_by_yourself
                  }}<span class="has-text-danger">*</span></label
                >
                <ValidationProvider name="Specify the assets held by your self" :rules="{ required: true, alphaSpaces: true, notStartsWith: ' ', notEndsWith:' '}" v-slot="{ errors }">
                <b-field>

                  <b-input v-model="$root.formData.other_assets_held"></b-input>
                </b-field>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

                <div class = "column is-4 column is-offset-2">
                  <label
                      :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.marketValue
                    }}<span class="has-text-danger">*</span></label
                  >
                  <b-field>
                    <ValidationProvider name="Market Value" :rules="{ required:$root.formData.asset_other===true}" v-slot="{ errors }">
                      <b-input v-model="$root.formData.asset_other_value" placeholder="Rs"
                               min="1"
                               max="999999999"
                               @input="
                                  () => {
                                    $inputChanged('asset_other_value');
                                    otherAssetsRegexValidator()
                                    otherAssetThousendSeperator()
                                    marketValueMinMaxValidator()
                                  } "
                      >
                      </b-input>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                      <span class="has-text-danger" v-if="!isMarketValueInRange"> Market value is not in valid range</span>
                      <span class="has-text-danger" v-if="!isotherAssetValueValid"> Market value is not in valid format</span>
                    </ValidationProvider>
                  </b-field>
                </div>

              </div>
              <!--           Other Assets selection end here -->

<!--              Source of income and expected turnover section start here-->

              <div class="mt-2 columns ">
                <div
                    class="is-5 column"

                >
                  <!--                v-if="$root.kycFieldVisibility.source_of_income"-->
                  <label
                      :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.source_of_income
                    }}<span class="has-text-danger">*</span></label
                  >
                  <div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <b-select
                          @focus="$inputFocused('source_of_income')"
                          @input="()=>{$inputChanged('source_of_income'); if($root.formData.source_of_income !== 'Other'){
                            $root.formData.other_source_of_income = ''
                          }}"
                          @blur="$inputBlured('source_of_income')"
                          v-model="$root.formData.source_of_income"

                          expanded
                      >
                        <option
                            v-for="income in $root.selectedLanguageData
                          .sourceOfIncomeList"
                            :key="income.value"
                            :value="income.value"
                        >
                          {{ income.langTranslation }}
                        </option>
                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

                <div
                    class="is-5 column is-offset-2"

                >
                  <!--                v-if="$root.kycFieldVisibility.source_of_income"-->
                  <label
                      :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.expected_turnover
                    }}<span class="has-text-danger">*</span></label
                  >
                  <div>
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <b-select
                          @focus="$inputFocused('expected_turnover')"
                          @input="$inputChanged('expected_turnover')"
                          @blur="$inputBlured('expected_turnover')"
                          v-model="$root.formData.expected_turnover"

                          expanded
                      >
                        <option
                            v-for="turnover in $root.selectedLanguageData
                          .transactionVolumesAndExpectedTurnovers"
                            :key="turnover.value"
                            :value="turnover"
                        >
                          {{ turnover.langTranslation }}
                        </option>
                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>

              </div>


              <!--              Source of income and expected turnover section end here-->


<!--              <div class="mt-4" >-->
<!--&lt;!&ndash;                v-if="$root.kycFieldVisibility.income_details"&ndash;&gt;-->
<!--                <label-->
<!--                  :class="`${-->
<!--                    $root.selectedLanguage === `ta`-->
<!--                      ? `ta-label`-->
<!--                      : $root.selectedLanguage === `si`-->
<!--                      ? `si-label`-->
<!--                      : ``-->
<!--                  }`"-->
<!--                >-->
<!--                  {{ $root.selectedLanguageData.incomeDetails-->
<!--                  }}<span class="has-text-danger">*</span></label-->
<!--                >-->
<!--                <ValidationProvider rules="required" v-slot="{ errors }">-->
<!--                  <div>-->
<!--                    <b-select-->
<!--                      @focus="$inputFocused('income_details')"-->
<!--                      @input="$inputChanged('income_details')"-->
<!--                      @blur="$inputBlured('income_details')"-->
<!--                      v-model="$root.formData.income_details"-->
<!--                   -->
<!--                      expanded-->
<!--                    >-->
<!--                      <option-->
<!--                        v-for="incomeDetail in $root.selectedLanguageData-->
<!--                          .sourceOfIncomeList"-->
<!--                        :key="incomeDetail.value"-->
<!--                        :value="incomeDetail"-->
<!--                      >-->
<!--                        {{ incomeDetail.langTranslation }}-->
<!--                      </option>-->
<!--                    </b-select>-->
<!--                  </div>-->
<!--                  <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                </ValidationProvider>-->
<!--              </div>-->

<!--              other source of income section start here-->
              <div class="mt-2" v-if="$root.formData.source_of_income == 'Other'" >

                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.specify_the_source_of_income
                  }}<span class="has-text-danger">*</span></label
                >
                <ValidationProvider name="Source of Income" :rules="{ required: true, alphaSpaces: true, notStartsWith: ' ', notEndsWith:' '}" v-slot="{ errors }" >
                <b-field>
                  <b-input
                      @focus="$inputFocused('other_source_of_income')"
                      @input="$inputChanged('other_source_of_income')"
                      @blur="$inputBlured('other_source_of_income')"
                      v-model="$root.formData.other_source_of_income"
                  ></b-input>
                </b-field>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!--              other source of income section end here-->

<!--              <div class="mt-4" >-->
<!--&lt;!&ndash;                v-if="$root.kycFieldVisibility.anticipated_vol"&ndash;&gt;-->
<!--                <label-->
<!--                  :class="`${-->
<!--                    $root.selectedLanguage === `ta`-->
<!--                      ? `ta-label`-->
<!--                      : $root.selectedLanguage === `si`-->
<!--                      ? `si-label`-->
<!--                      : ``-->
<!--                  }`"-->
<!--                  >{{ $root.selectedLanguageData.specify_the_source_of_income-->
<!--                  }}<span class="has-text-danger">*</span></label-->
<!--                >-->
<!--                <ValidationProvider rules="required" v-slot="{ errors }">-->
<!--                  <div>-->
<!--                    <b-select-->
<!--                      @focus="$inputFocused('anticipated_vol')"-->
<!--                      @input="$inputChanged('anticipated_vol')"-->
<!--                      @blur="$inputBlured('anticipated_vol')"-->
<!--                      v-model="$root.formData.anticipated_vol"-->
<!--                      -->
<!--                      expanded-->
<!--                    >-->
<!--                      <option-->
<!--                        v-for="anticipatedDepositsAmount in $root-->
<!--                          .selectedLanguageData.anticipatedDepositsAmountList"-->
<!--                        :key="anticipatedDepositsAmount.value"-->
<!--                        :value="anticipatedDepositsAmount"-->
<!--                      >-->
<!--                        {{ anticipatedDepositsAmount.langTranslation }}-->
<!--                      </option>-->
<!--                    </b-select>-->
<!--                  </div>-->
<!--                  <span class="has-text-danger">{{ errors[0] }}</span>-->
<!--                </ValidationProvider>-->
<!--              </div>-->


              <div
                class="mt-4"

              >
<!--                v-if="$root.kycFieldVisibility.expected_delivery_channel"-->
                <label
                  :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.expectedModeOfTransaction
                  }}<span class="has-text-danger">*</span></label
                >
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <div>
                    <b-select
                      expanded
                      @focus="$inputFocused('expected_mode_of_transaction')"
                      @input="()=>{$inputChanged('expected_mode_of_transaction'); if($root.formData.expected_mode_of_transaction !== 'Other'){
                        $root.formData.other_expected_mode_of_transaction = ''
                      }}"
                      @blur="$inputBlured('expected_mode_of_transaction')"
                      v-model="$root.formData.expected_mode_of_transaction"
                    >
                      <option
                        v-for="expectedModeOfTransaction in $root
                          .selectedLanguageData.expectedModeOfTransactionList"
                        :key="expectedModeOfTransaction.value"
                        :value="expectedModeOfTransaction.value"
                      >
                        {{ expectedModeOfTransaction.langTranslation }}
                      </option>
                    </b-select>
                  </div>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="mt-2" v-if="$root.formData.expected_mode_of_transaction== 'Other'" >

                <label
                    :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                >{{ $root.selectedLanguageData.other_mode_of_transaction
                  }}<span class="has-text-danger">*</span></label
                >
                <ValidationProvider name="Expected Mode of Transaction" :rules="validateValue()" v-slot="{ errors }">
                <b-field>
                  <b-input v-model="$root.formData.other_expected_mode_of_transaction"></b-input>
                </b-field>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- <div class="mt-4">
              <div>
                <label>{{
                  $root.selectedLanguageData.assetsHeldByYourself
                }}</label>

                  <section>
                    <b-field>
                      <div class="columns">
                        <div
                          class="column is-one-two is-flex is-align-content-center"
                        >
                          <b-checkbox
                            type="is-info"
                            native-value="ResidentialProperty"
                            v-model="$root.formData.residentialProperty"
                            >{{
                              $root.selectedLanguageData.residentialProperty
                            }}</b-checkbox
                          >
                        </div>
                        <div
                          class="column is-one-two"
                          v-if="$root.formData.residentialProperty"
                        >
                          <ValidationProvider
                            name="Value"
                            :rules="validationAssetsHeldByYourSelf()"
                            v-slot="{ errors }"
                          >
                            <b-input
                              rounded
                              type="number"
                              placeholder="Rs.000,000,000"
                              v-model="$root.formData.valueofresidentialProperty"
                              v-if="$root.formData.residentialProperty"
                            />
                            <span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-field>
                    <b-field>
                      <div class="columns">
                        <div
                          class="column is-one-two is-flex is-align-content-center"
                        >
                          <b-checkbox
                            native-value="MotorVehicle"
                            v-model="$root.formData.motorVehicle"
                            >{{
                              $root.selectedLanguageData.motorVehicle
                            }}</b-checkbox
                          >
                        </div>
                        <div
                          class="column is-one-two"
                          v-if="$root.formData.motorVehicle"
                        >
                          <ValidationProvider
                            name="Value"
                            :rules="validationAssetsHeldByYourSelf()"
                            v-slot="{ errors }"
                          >
                            <b-input
                              rounded
                              type="number"
                              placeholder="Rs.000,000,000"
                              v-model="$root.formData.valueofmotorVehicle"
                              v-if="$root.formData.motorVehicle"
                            /><span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-field>
                    <b-field>
                      <div class="columns">
                        <div
                          class="column is-one-two is-flex is-align-content-center"
                        >
                          <b-checkbox
                            native-value="LandBuildings"
                            v-model="$root.formData.landBuilding"
                            >{{
                              $root.selectedLanguageData.landBuildings
                            }}</b-checkbox
                          >
                        </div>
                        <div
                          class="column is-one-two"
                          v-if="$root.formData.landBuilding"
                        >
                          <ValidationProvider
                            name="Value"
                            :rules="validationAssetsHeldByYourSelf()"
                            v-slot="{ errors }"
                          >
                            <b-input
                              rounded
                              type="number"
                              placeholder="Rs.000,000,000"
                              v-model="$root.formData.valueoflandBuildings"
                              v-if="$root.formData.landBuilding"
                            /><span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-field>
                    <b-field>
                      <div class="columns">
                        <div
                          class="column is-one-two is-flex is-align-content-center"
                        >
                          <b-checkbox
                            native-value="InvestmentShares"
                            v-model="$root.formData.investmentShares"
                            >{{
                              $root.selectedLanguageData.investmentShares
                            }}</b-checkbox
                          >
                        </div>
                        <div
                          class="column is-one-two"
                          v-if="$root.formData.investmentShares"
                        >
                          <ValidationProvider
                            name="Value"
                            :rules="validationAssetsHeldByYourSelf()"
                            v-slot="{ errors }"
                          >
                            <b-input
                              rounded
                              type="number"
                              placeholder="Rs.000,000,000"
                              v-model="$root.formData.valueofinvestmentShares"
                              v-if="$root.formData.investmentShares"
                            /><span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-field>
                    <b-field>
                      <div class="columns">
                        <div
                          class="column is-one-two is-flex is-align-content-center"
                        >
                          <b-checkbox
                            native-value="Others"
                            v-model="$root.formData.others"
                            >{{ $root.selectedLanguageData.others }}</b-checkbox
                          >
                        </div>
                        <div
                          class="column is-one-two"
                          v-if="$root.formData.others"
                        >
                          <ValidationProvider
                            name="Value"
                            :rules="validationAssetsHeldByYourSelf()"
                            v-slot="{ errors }"
                          >
                            <b-input
                              rounded
                              type="number"
                              placeholder="Rs.000,000,000"
                              v-model="$root.formData.valueofothers"
                              v-if="$root.formData.others"
                            /><span class="has-text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-field>
                  </section>
                </div>
              </div>-->
            </div>
          </transition>
        </div>

        <transition
          appear
          @before-enter="$animations.beforeEnterBelow"
          @enter="$animations.enterBelow"
        >
          <div class="is-centered columns my-3">
            <div class="column is-5 is-offset-4 is-flex is-flex-direction-row-reverse">
<!--              :disabled="-->
<!--              invalid ||-->
<!--              ($root.kycFieldVisibility.purpose_of_opening-->
<!--              ? !$root.formData.purpose_of_opening-->
<!--              : false) ||-->
<!--              ($root.kycFieldVisibility.purpose_of_opening-->
<!--              ? $root.formData.purpose_of_opening.langTranslation !==-->
<!--              purpose-->
<!--              : false)-->
<!--              "-->
              <b-button
                :disabled="invalid  ||(!$root.formData.asset_residential_property &&
                !$root.formData.asset_financial &&
                !$root.formData.asset_motor_vehicles &&
                !$root.formData.asset_land_buildings &&
                !$root.formData.asset_investments_shares &&
                !$root.formData.asset_other) || allAssetsInRangeValidator() === false"
                :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"

                @click="submitPageInputs(isContinueButtonLoading, 'documents_id', 'personal-info', 'documents_id', 1)"
                >{{ $root.selectedLanguageData.continue }}</b-button
              >
              <b-button
                :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"
                @click="previousRouteHandler()"
                >{{ $root.selectedLanguageData.back }}</b-button>
            </div>
          </div>
        </transition>
      </form>
    </ValidationObserver>
  </div>
    <GetHelp v-if="false"></GetHelp>
  </div>
</template>

<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import { separateByThousands } from "separate-user-input-by-thousands";
import {submitPageInputs} from "@/util/util";

export default {
  components: {
    GetHelp,
    Logo,
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      textArea: false,
      purpose: "",
      propertyValue : '',
      financialValue : '',
      landBuildingsValue : '',
      investmentsValue : '',
      motorVehiclesValue : '',
      otherAssetValue : '',
      isPurposeTouched: false,
      isPropertyValueInRange: true,
      isFinancialValueInRange: true,
      isBusinessValueInRange: true,
      isInvestmentValueInRange: true,
      isMotorValueInRange: true,
      isMarketValueInRange: true,
      submitPageInputs: submitPageInputs,
      isContinueButtonLoading : false,
      previousRoute : '',
      assetRegEx : /^[\d,]+$/,
      isPropertyValueValid : true,
      isfinancialValueValid  : true,
      islandBuildingsValueValid  : true,
      isinvestmentsValueValid : true,
      ismotorVehiclesValueValid : true,
      isotherAssetValueValid : true


    };
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
      console.log(vm.previousRoute," previousRoute")
    });
  },

  methods: {

  propertyRegexValidator(){
   this.isPropertyValueValid =  this.assetRegEx.test(this.$root.formData.asset_residential_property_value)
    // console.log("this.isPropertyIsValid", this.isPropertyIsValid)
      
    },
    financialRegexValidator(){
   this.isfinancialValueValid =  this.assetRegEx.test(this.$root.formData.asset_financial_value)
    // console.log("this.isPropertyIsValid", this.isPropertyIsValid)
      
    },

  landBuildingsRegexValidator(){
   this.islandBuildingsValueValid =  this.assetRegEx.test(this.$root.formData.asset_land_buildings_value)
    // console.log("this.isPropertyIsValid", this.isPropertyIsValid)
      
    },

  investmentsRegexValidator(){
   this.isinvestmentsValueValid =  this.assetRegEx.test(this.$root.formData.asset_investments_shares_value)
    // console.log("this.isPropertyIsValid", this.isPropertyIsValid)
      
    },

    motorVehiclesRegexValidator(){
   this.ismotorVehiclesValueValid =  this.assetRegEx.test(this.$root.formData.asset_motor_vehicles_value)
    // console.log("this.isPropertyIsValid", this.isPropertyIsValid)
      
    },

  otherAssetsRegexValidator(){
   this.isotherAssetValueValid =  this.assetRegEx.test(this.$root.formData.asset_other_value)
    // console.log("this.isPropertyIsValid", this.isPropertyIsValid)
      
    },


    propertyThousendSeperator(){
      const getValue = separateByThousands(
          this.$root.formData.asset_residential_property_value,
          this.propertyValue
      );
      this.propertyValue = getValue;
      this.$root.formData.asset_residential_property_value = getValue;
      console.log(getValue);
    },

    previousRouteHandler(){
      // if (this.previousRoute.fullPath === '/personal-info'){
      //   this.$router.push('personal-info')
      // }
      // else {
      //   this.$router.push('/guardians_information')
      // }

      if(this.$root.formData.account === `Minor Savings` || this.$root.formData.haveNic === 'No'){
        this.$router.push('/guardians_information');
      }
      else {
        this.$router.push('/personal-info');
      }
    },

    formatDate(date){
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate()

      if(month < 10){
        month = "0"+month;
      }
      let output = [month,day,year]
      return output.join("/")
    },
    financialAssetThousendSeperator(){
      const getValue = separateByThousands(
          this.$root.formData.asset_financial_value,
          this.financialValue
      );
      this.financialValue = getValue;
      this.$root.formData.asset_financial_value = getValue;
      console.log(getValue);
    },

    landBuildingsAssetThousendSeperator(){
      const getValue = separateByThousands(
          this.$root.formData.asset_land_buildings_value,
          this.landBuildingsValue
      );
      this.landBuildingsValue = getValue;
      this.$root.formData.asset_land_buildings_value = getValue;
      console.log(getValue);
    },

    investmentsAssetThousendSeperator(){
      const getValue = separateByThousands(
          this.$root.formData.asset_investments_shares_value,
          this.investmentsValue
      );
      this.investmentsValue = getValue;
      this.$root.formData.asset_investments_shares_value = getValue;
      console.log(getValue);
    },

    motorVehicalsAssetThousendSeperator(){
      const getValue = separateByThousands(
          this.$root.formData.asset_motor_vehicles_value,
          this.motorVehiclesValue
      );
      this.motorVehiclesValue = getValue;
      this.$root.formData.asset_motor_vehicles_value = getValue;
      console.log(getValue);
    },

    otherAssetThousendSeperator(){
      const getValue = separateByThousands(
          this.$root.formData.asset_other_value,
          this.otherAssetValue
      );
      this.otherAssetValue = getValue;
      this.$root.formData.asset_other_value = getValue;
      console.log(getValue);
    },



    // removeItem(item) {
    //   if (this.$root.formData.purpose_of_opening.includes(item)) {
    //     this.$root.formData.purpose_of_opening =
    //       this.$root.formData.purpose_of_opening.filter(
    //         (element) => element !== item
    //       );
    //   }
    // },
    // valueRemover(purpose, purposeValue){
    //   console.log("valueRemover() called!");
    //   if (purpose === false){
    //     // eslint-disable-next-line no-unused-vars
    //     purposeValue = ""
    //   }
    //
    // },
    // thousendSeperator : function (){
    //   if(this.$root.formData.asset_residential_property_value !== ''){
    //     this.$root.formData.asset_residential_property_value.toString().split(".");
    //     this.$root.formData.asset_residential_property_value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     this.$root.formData.asset_residential_property_value.join()
    //   }
    //
    //
    // },
    // assetsMinMaxValidator(isAssetValueInRange, assetValueInput){
    //
    //   let assetValue =  assetValueInput.replaceAll(',', '');
    //   parseInt(assetValue);
    //   console.log(assetValue)
    //   if(assetValue<=1 || assetValue>=999999999){
    //
    //      isAssetValueInRange = false
    //     // console.log(isAssetValueInRange)
    //   }
    //   else {
    //
    //     isAssetValueInRange = true
    //     // console.log(isAssetValueInRange)
    //   }
    // },

    propertyMinMaxValidator(){

      let assetValue =  this.$root.formData.asset_residential_property_value.replaceAll(',', '');
      parseInt(assetValue);
      console.log(assetValue)
      if(assetValue<100000 || assetValue>1000000000){

        this.isPropertyValueInRange = false
        // console.log(isAssetValueInRange)
      }
    
      else {

        this.isPropertyValueInRange = true
        // console.log(isAssetValueInRange)
      }
    },

    financialMinMaxValidator(){

      let assetValue =  this.$root.formData.asset_financial_value.replaceAll(',', '');
      parseInt(assetValue);
      console.log(assetValue)
      if(assetValue<100000 || assetValue>1000000000){

        this.isFinancialValueInRange = false
        // console.log(isAssetValueInRange)
      }
      else {

        this.isFinancialValueInRange = true
        // console.log(isAssetValueInRange)
      }
    },

    // financialMinMaxValidator(){
    //
    //   let assetValue =  this.$root.formData.asset_financial_value.replaceAll(',', '');
    //   parseInt(assetValue);
    //   console.log(assetValue)
    //   if(assetValue<=1 || assetValue>=999999999){
    //
    //     this.isFinancialValueInRange = false
    //     // console.log(isAssetValueInRange)
    //   }
    //   else {
    //
    //     this.isFinancialValueInRange = true
    //     // console.log(isAssetValueInRange)
    //   }
    // },

    landBuildingMinMaxValidator(){

      let assetValue =  this.$root.formData.asset_land_buildings_value.replaceAll(',', '');
      parseInt(assetValue);
      console.log(assetValue)
      if(assetValue<100000 || assetValue>1000000000){
        this.isBusinessValueInRange = false
        // console.log(isAssetValueInRange)
      }
      else {
        this.isBusinessValueInRange = true
        // console.log(isAssetValueInRange)
      }
    },

    investmentSharesMinMaxValidator(){

      let assetValue =  this.$root.formData.asset_investments_shares_value.replaceAll(',', '');
      parseInt(assetValue);
      console.log(assetValue)
      if(assetValue<100000 || assetValue>1000000000){
        this.isInvestmentValueInRange = false
        // console.log(isAssetValueInRange)
      }
      else {
        this.isInvestmentValueInRange = true
        // console.log(isAssetValueInRange)
      }
    },

    motorVehiclesMinMaxValidator(){

      let assetValue =  this.$root.formData.asset_motor_vehicles_value.replaceAll(',', '');
      parseInt(assetValue);
      console.log(assetValue)
      if(assetValue<100000 || assetValue>1000000000){
        this.isMotorValueInRange = false
        // console.log(isAssetValueInRange)
      }
      else {
        this.isMotorValueInRange = true
        // console.log(isAssetValueInRange)
      }
    },

    marketValueMinMaxValidator(){

      let assetValue =  this.$root.formData.asset_other_value.replaceAll(',', '');
      parseInt(assetValue);
      console.log(assetValue)
      if(assetValue<100000 || assetValue>1000000000){
        this.isMarketValueInRange = false
        // console.log(isAssetValueInRange)
      }
      else {
        this.isMarketValueInRange = true
        // console.log(isAssetValueInRange)
      }
    },

    allAssetsInRangeValidator(){
      if(this.isPropertyValueInRange && this.isFinancialValueInRange && this.isFinancialValueInRange && this.isBusinessValueInRange && this.isInvestmentValueInRange && this.isMotorValueInRange && this.isMarketValueInRange){
        return true
      }
      else{
        return false
      }
    },










    validateValue: function () {
      const obj = {
        required: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: "  ",
        includes: " ",

      };
      return obj;
    },

    validateOtherAssets: function () {
      const obj = {
        required: this.$root.formData.asset_other,
        alphaSpaces: true,
        notStartsWith: " ",
        notEndsWith: " ",
        notConsecutive: " ",
      };
      return obj;
    },

    assetsValidate: function () {
      const obj = {
        required: true,
        regex: /^\d+(\.\d+)?$/,
      };
      return obj;
    },

    showTextArea() {
      this.textArea = true;
    },

    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
        console.log('kyc token',kyc_token);
        this.$http
          .post(this.$baseURL + "/kycForm/updateLastStep", {
            last_step_name:'Pursonal Info',
            last_step: 3,
            form_filled:true,
            next_route:'Purpose Info',

          },{
            headers:{'X-token':kyc_token}
          })
          .then((response) => {
            console.log(response.data);

            if (response.data.success) {
              console.log(response.data);
            } else {
              console.log(response.data);
            }
          }).catch((response) => {
            this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
            });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },
    validationAssetsHeldByYourSelf() {
      const obj = {
        required: true,
        numberRange: { min: 0, max: 999999999 },
      };
      return obj;
    },



    handleInput (assetValueInput) {
      // Format the input value with thousand separators
      assetValueInput = assetValueInput.replace(/[^0-9.]/g, '');
      assetValueInput = this.addThousandSeparators(assetValueInput)
      console.log(assetValueInput)
    },
    addThousandSeparators (value) {
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    },



  },
  mounted: function () {
    // this.updateLastStep();
    if (this.$root.formData.purpose_of_opening) {
      const purposeValue = this.$root.formData.purpose_of_opening.value;
      const purposeOption = this.$root.selectedLanguageData.purposeList.find(
        (search) => search.value === purposeValue
      );
      this.purpose = purposeOption.langTranslation;
    }
  },
  computed: {
    filteredDataArray() {
      return this.$root.selectedLanguageData.purposeList.filter((option) => {
        return (
          option.value.toLowerCase().indexOf(this.purpose.toLowerCase()) >= 0
        );
      });
    },



  },


  watch: {
    "$root.selectedLanguage": function () {
      if (
        this.$root.formData.purpose_of_opening.langTranslation !== this.purpose
      ) {
        this.$root.formData.purpose_of_opening = "";
        this.purpose = "";
      } else {
        const purposeValue = this.$root.formData.purpose_of_opening.value;
        const purposeOption = this.$root.selectedLanguageData.purposeList.find(
          (search) => search.value === purposeValue
        );
        this.purpose = purposeOption.langTranslation;
        this.$root.formData.purpose_of_opening = purposeOption;
      }
      // SourceOfIncome
      const tempSourceOfIncome = this.$root.formData.source_of_income.value;
      const tempSourceOfIncomeObject =
        this.$root.selectedLanguageData.sourceOfIncomeList.find(
          (search) => search.value === tempSourceOfIncome
        );
      this.$root.formData.source_of_income = tempSourceOfIncomeObject;
      // anticipated_vol
      const tempAnticipatedVol = this.$root.formData.anticipated_vol.value;
      const tempAnticipatedVolObject =
        this.$root.selectedLanguageData.anticipatedDepositsAmountList.find(
          (search) => search.value === tempAnticipatedVol
        );
      this.$root.formData.anticipated_vol = tempAnticipatedVolObject;
      // expected_delivery_channel
      const tempExpectedDelivery =
        this.$root.formData.expected_delivery_channel.value;
      const tempExpectedDeliveryObject =
        this.$root.selectedLanguageData.expectedModeOfTransactionList.find(
          (search) => search.value === tempExpectedDelivery
        );
      this.$root.formData.expected_delivery_channel =
        tempExpectedDeliveryObject;
      // income_details
      const tempIncomeDetails = this.$root.formData.income_details.value;
      const tempIncomeDetailsObject =
        this.$root.selectedLanguageData.incomeDetailsList.find(
          (search) => search.value === tempIncomeDetails
        );
      this.$root.formData.income_details = tempIncomeDetailsObject;
    },
    // "$root.formData.asset_residential_property_value" : function (){
    //   if(this.$root.formData.asset_residential_property_value !== ''){
    //     // newAsset_residential_property_value = oldAsset_residential_property_value.toString().split(".");
    //     // newAsset_residential_property_value[0] = newAsset_residential_property_value[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     // newAsset_residential_property_value.join()
    //     // this.$root.formData.asset_residential_property_value.toString().split(".");
    //     this.$root.formData.asset_residential_property_value.toString().replace(/[^0-9]/g, "");
    //     this.$root.formData.asset_residential_property_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    //     // this.$root.formData.asset_residential_property_value.join()
    //     // console.log("New values",newAsset_residential_property_value)
    //   }
    // },


  },
};
</script>
<style scoped></style>
